import { Text } from "@mantine/core";
import { useInputStyles } from "./FieldTextValue";

export default function FieldLabel({ label }: { label: string }) {
  const { classes } = useInputStyles();
  return <Text className={classes.label}>{label}</Text>;
}
